import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "flex flex-col"
};
const _hoisted_2 = {
  key: 0,
  class: "bg-red-100 text-red-800 font-bold p-4 text-center"
};
const _hoisted_3 = {
  key: 1,
  class: "bg-green-100 text-green-800 font-bold p-4 text-center"
};
const _hoisted_4 = {
  class: "py-2"
};
const _hoisted_5 = {
  class: "flex-center items-center mb-4"
};
const _hoisted_6 = {
  class: "flex"
};
const _hoisted_7 = {
  key: 0,
  class: "flex"
};
const _hoisted_8 = {
  key: 1,
  class: "p-2 mt-4"
};
const _hoisted_9 = {
  class: "flex justify-between"
};
import { NegotiationStatusEnum } from "@/modules/diplomacy/enums";
import { app } from "@/di";
import { NegotiationCloser } from "@/modules/diplomacy/services/NegotiationCloser";
import { Progress, ProgressMarker } from "@/modules/vue/components";
import { ColorEnum } from '@/modules/vue/enums';
import Status from "@/modules/vue/components/Status.vue";
import Gate from "@/modules/action-points/components/Gate.vue";
import { GateTypeEnum } from "@/modules/action-points/enums";
import { NegotiationEvaluator } from "@/modules/diplomacy/services/NegotiationEvaluator";
import FormGroup from "@/modules/vue/components/FormGroup.vue";
import AttributeGroup from "@/modules/vue/components/AttributeGroup.vue";
import Icon from "@/modules/vue/components/Icon.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Negotiation',
  props: {
    negotiation: null,
    hideAlert: {
      type: Boolean
    },
    showAttributes: {
      type: Boolean
    },
    notClosable: {
      type: Boolean
    },
    notAbortable: {
      type: Boolean
    }
  },
  emits: ['closed', 'updated'],
  async setup(__props, {
    emit
  }) {
    let __temp, __restore;
    const props = __props;
    const closer = ([__temp, __restore] = _withAsyncContext(() => app.get(NegotiationCloser)), __temp = await __temp, __restore(), __temp);
    const negotiationStatusColors = ref({
      [NegotiationStatusEnum.OPENED]: ColorEnum.Green,
      [NegotiationStatusEnum.CLOSED]: ColorEnum.Indigo,
      [NegotiationStatusEnum.FAILED]: ColorEnum.Red
    });
    const canClose = ref(([__temp, __restore] = _withAsyncContext(() => closer.can(props.negotiation)), __temp = await __temp, __restore(), __temp));
    const abort = async () => await closer.abort(props.negotiation);
    const close = async () => {
      await closer.close(props.negotiation);
      emit('closed');
    };
    const onClose = async commit => {
      await closer.close(props.negotiation);
      await commit();
      emit('closed');
    };
    const onNegotiate = async commit => {
      await app.get(NegotiationEvaluator).evaluate(props.negotiation);
      await commit();
      emit('updated');
    };
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return __props.negotiation.target ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_renderSlot(_ctx.$slots, "before"), !__props.hideAlert ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [__props.negotiation.status === _unref(NegotiationStatusEnum).FAILED ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("p", null, _toDisplayString(_ctx.$t('negotiation_failed')), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t('negotiation_target_does_not_want_to_talk_to_you')), 1)])) : __props.negotiation.status === _unref(NegotiationStatusEnum).CLOSED ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("p", null, _toDisplayString(_ctx.$t('negotiation_closed')), 1)])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "target", {}, () => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(Status, {
        colors: negotiationStatusColors.value,
        value: __props.negotiation.status,
        class: "mr-2 p-1"
      }, null, 8, ["colors", "value"]), _renderSlot(_ctx.$slots, "target-title", {}, () => [_createTextVNode(_toDisplayString(_ctx.$t('target')), 1)])]), _renderSlot(_ctx.$slots, "target-start"), _ctx.$debug ? (_openBlock(), _createBlock(AttributeGroup, {
        key: 0,
        class: "mx-2",
        title: _ctx.$t('negotiation_attributes'),
        attributes: [{
          label: _ctx.$t('patience'),
          percentage: __props.negotiation.target.patience
        }, {
          label: _ctx.$t('greediness'),
          percentage: __props.negotiation.target.greediness
        }, {
          label: _ctx.$t('resentfulness'),
          percentage: __props.negotiation.target.resentfulness
        }]
      }, null, 8, ["title", "attributes"])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "target-end")])]), _createVNode(AttributeGroup, {
        class: "mx-2",
        title: _ctx.$t('negotiation_progress'),
        color: _unref(ColorEnum).Sky
      }, {
        default: _withCtx(() => [_createVNode(FormGroup, {
          label: _ctx.$t('progress'),
          narrow: ""
        }, {
          default: _withCtx(() => [_createVNode(_unref(Progress), {
            value: __props.negotiation.progress
          }, {
            default: _withCtx(() => [Number.isInteger(__props.negotiation.progressCloseLimit) ? (_openBlock(), _createBlock(_unref(ProgressMarker), {
              key: 0,
              value: __props.negotiation.progressCloseLimit,
              color: _unref(ColorEnum).Green
            }, null, 8, ["value", "color"])) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["value"])]),
          _: 1
        }, 8, ["label"]), _createVNode(FormGroup, {
          label: _ctx.$t('patience'),
          narrow: ""
        }, {
          default: _withCtx(() => [_createVNode(_unref(Progress), {
            value: __props.negotiation.patience
          }, {
            default: _withCtx(() => [_createVNode(_unref(ProgressMarker), {
              value: __props.negotiation.patienceAbortLimit,
              color: _unref(ColorEnum).Red
            }, null, 8, ["value", "color"])]),
            _: 1
          }, 8, ["value"])]),
          _: 1
        }, 8, ["label"])]),
        _: 1
      }, 8, ["title", "color"]), _renderSlot(_ctx.$slots, "balance", {}, () => [_createElementVNode("div", _hoisted_6, [_createVNode(FormGroup, {
        label: _ctx.$t('monthly'),
        "value-width-ratio": 1 / 2,
        class: "flex-1"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$moneyPerMonth(__props.negotiation.monthly)), 1)]),
        _: 1
      }, 8, ["label"]), _createVNode(FormGroup, {
        label: _ctx.$t('once'),
        "value-width-ratio": 1 / 2,
        class: "flex-1"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$money(__props.negotiation.once)), 1)]),
        _: 1
      }, 8, ["label"])]), _ctx.$debug ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(FormGroup, {
        label: _ctx.$t('monthly'),
        "value-width-ratio": 1 / 2,
        class: "flex-1"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$moneyPerMonth(__props.negotiation.monthlyFrom)) + " - " + _toDisplayString(_ctx.$moneyPerMonth(__props.negotiation.monthlyTo)), 1)]),
        _: 1
      }, 8, ["label"]), _createVNode(FormGroup, {
        label: _ctx.$t('once'),
        "value-width-ratio": 1 / 2,
        class: "flex-1"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$money(__props.negotiation.onceFrom)) + " - " + _toDisplayString(_ctx.$money(__props.negotiation.onceTo)), 1)]),
        _: 1
      }, 8, ["label"])])) : _createCommentVNode("", true)]), _renderSlot(_ctx.$slots, "after-balance"), __props.negotiation.status === _unref(NegotiationStatusEnum).OPENED ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [!__props.notAbortable ? (_openBlock(), _createBlock(_component_NButton, {
        key: 0,
        type: "error",
        secondary: "",
        onClick: abort
      }, {
        default: _withCtx(() => [_createVNode(Icon, {
          icon: _ctx.IconEnum.CloseOutline
        }, null, 8, ["icon"])]),
        _: 1
      })) : _createCommentVNode("", true), !__props.notClosable && __props.negotiation.canBeClosed ? (_openBlock(), _createBlock(Gate, {
        key: 1,
        type: _unref(GateTypeEnum).BALANCE,
        value: __props.negotiation.total,
        meta: __props.negotiation.gateMeta,
        disabled: !__props.negotiation.canBeClosed || !canClose.value,
        class: "mr-2",
        onAction: onClose
      }, {
        label: _withCtx(() => [_createVNode(Icon, {
          icon: _ctx.IconEnum.CheckRound
        }, null, 8, ["icon"])]),
        _: 1
      }, 8, ["type", "value", "meta", "disabled"])) : _createCommentVNode("", true), _createVNode(Gate, {
        type: _unref(GateTypeEnum).NEGOTIATION,
        value: _ctx.$config('negotiation.actionPointsCosts.general'),
        disabled: __props.negotiation.progressCompleted,
        "no-confirm": "",
        onAction: onNegotiate
      }, null, 8, ["type", "value", "disabled"])])])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "after")])) : _createCommentVNode("", true);
    };
  }
});